import {Component, Input, OnChanges} from '@angular/core';

@Component({
    selector: 'dots',
    template: `
      <ul *ngIf="count > 1" class="eva-3-nav-dots -center dots-container" [ngClass]="{'-lighten': lighten}">
        <li *ngFor="let dot of dots; let i=index" class="nav-dot" [ngClass]="{'-active': currentPage === i}"></li>
      </ul>
    `
})
export class DotsComponent implements OnChanges {
    @Input() count: number;
    @Input() currentPage: number;
    @Input() lighten?: boolean;

    dots: Array<any> = [];

    constructor() {
    }

    ngOnChanges(): void {
        this.dots = new Array(this.count).fill({});
    }
}
